import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { RouterModule } from '@angular/router';
import { PortalModule } from '@angular/cdk/portal';

// app components
// material
import { MatSortModule } from '@angular/material/sort';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatTableModule } from '@angular/material/table';
import { MatInputModule } from '@angular/material/input';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatDatepickerModule,  MatNativeDateModule} from '@angular/material';
import { NgSelectModule} from '@ng-select/ng-select';

// page parts components
import { NavMenuComponent } from './shared/components/layout/nav-menu/nav-menu.component';

//import { LoginComponent } from './login/login.component';

// page components
import { HomeComponent } from './components/home/home.component';
import { BrandsComponent } from './components/brands/brands.component';
import { BrandDetailsComponent } from './components/brand-details/brand-details.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { ReportsComponent } from './components/reports/reports.component';
import { MailingsComponent } from './components/mailings/mailings.component';
import { MailingDetailsComponent } from './components/mailing-details/mailing-details.component';
import { BillingComponent } from './components/billing/billing.component';
import { MailingRecordListComponent } from './components/mailing-record-list/mailing-record-list.component';
import { LocationsComponent } from './components/locations/locations.component';
import { SubBrandsComponent } from './components/subbrands/subbrands.component';
import { MatrixComponent } from './components/matrix/matrix.component';
import { MatrixQueryBuilderComponent } from './components/matrix-query-builder/matrix-query-builder.component';
import { OverrideRulesComponent } from './components/override-rules/override-rules.component';
import { QCReportComponent } from './components/qc-report/qc-report.component';
import { MonthConversionsComponent } from './components/month-conversions/month-conversions.component';

// shared components
import { SpinnerComponent } from './shared/components/spinner/spinner.component';
import { ModalComponent } from './shared/components/modals/modal/modal.component';
import { LocationAddFormComponent } from './shared/components/modals/location-add-modal/location-add.component';
import { LocationEditFormComponent } from './shared/components/modals/location-edit-modal/location-edit.component';
import { ConfirmationModalComponent } from './shared/components/modals/confirmation-modal/confirmation-modal.component';
import { BrandPickerComponent } from './shared/components/modals/brand-picker-modal/brand-picker.component';
import { CreativeTemplateEditFormComponent } from './shared/components/modals/creative-template-edit-modal/creative-template-edit.component';
import { CreativeTemplateAddFormComponent } from './shared/components/modals/creative-template-add-modal/creative-template-add.component';
import { OverrideRuleEditFormComponent } from './shared/components/modals/override-rule-edit-modal/override-rule-edit.component';
import { OverrideRuleAddFormComponent } from './shared/components/modals/override-rule-add-modal/override-rule-add.component';


// custom data types
import { YesNoPipe } from './shared/pipes/yesno.pipe';
import { FilterPipe } from './shared/pipes/filter.pipe';
import { ExcludeDuplicatesPipe } from './shared/pipes/excludeDuplicates.pipe';
import { FilterMonthsByCampaignPipe } from './shared/pipes/filterMonthsByCampaign.pipe';
import { TruncateStringPipe } from './shared/pipes/truncateString.pipe';

// date pipe
import { DatePipe } from '@angular/common';

// main app
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

// authorization modules
import { ApiAuthorizationModule } from 'src/api-authorization/api-authorization.module';
import { AuthorizeGuard } from 'src/api-authorization/authorize.guard';
import { AuthorizeInterceptor } from 'src/api-authorization/authorize.interceptor';

//ng bootstrap
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { MailingRecordEditFormComponent } from './shared/components/modals/mailing-record-edit-modal/mailing-record-edit.component';



//import { SpinnerDirective } from './shared/components/spinner/spinner.directive';
import { LoaderComponent } from './shared/components/loader/loader.component';
import { MonthConversionFormComponent } from './shared/components/modals/month-conversion-modal/month-conversion-form.component';
import { MailingFilesComponent } from './components/mailing-files/mailing-files.component';
import { BrandSeedsComponent } from './components/brand-seeds/brand-seeds.component';
import { BrandSeedFormComponent } from './shared/components/modals/brand-seed-modal/brand-seed-form.component';
import { LocationOverridesComponent } from './components/location-overrides/location-overrides.component';
import { LocationOverrideFormComponent } from './shared/components/modals/location-override-modal/location-override-form.component';
import { NotesComponent } from './components/notes/notes.component';
import { NoteFormComponent } from './shared/components/modals/note-modal/note-form.component';
import { MailingNotesComponent } from './components/mailing-notes/mailing-notes.component';

@NgModule({ 
  declarations: [
    AppComponent,
    NavMenuComponent,
    HomeComponent,   
    BrandsComponent,
    BrandSeedsComponent,
    BrandDetailsComponent,
    DashboardComponent,
    ReportsComponent,
    MailingsComponent,
    MailingDetailsComponent,
    MailingRecordListComponent,
    BillingComponent,
    YesNoPipe,
    FilterPipe,
    ExcludeDuplicatesPipe,
    FilterMonthsByCampaignPipe,
    TruncateStringPipe,
    SpinnerComponent,
    LocationsComponent,
    LocationOverridesComponent,
    ModalComponent,
    LocationAddFormComponent,
    LocationEditFormComponent,
    LocationOverrideFormComponent,
    ConfirmationModalComponent,
    SubBrandsComponent,
    BrandPickerComponent,
    MatrixComponent,
    MatrixQueryBuilderComponent,
    OverrideRulesComponent,
    CreativeTemplateEditFormComponent,
    CreativeTemplateAddFormComponent,
    OverrideRuleEditFormComponent,
    OverrideRuleAddFormComponent,
    MailingRecordEditFormComponent,
    QCReportComponent,
    LoaderComponent,
    MonthConversionsComponent,
    MonthConversionFormComponent,
    MailingFilesComponent,
    BrandSeedFormComponent,
    MailingNotesComponent,
    NotesComponent,
    NoteFormComponent
    //SpinnerDirective,
  ],
  imports: [
    BrowserModule.withServerTransition({ appId: 'ng-cli-universal' }),
    HttpClientModule,
    FormsModule,
    ApiAuthorizationModule,
    ReactiveFormsModule,
    NgSelectModule,
    PortalModule,
    RouterModule.forRoot([
      { path: '', component: HomeComponent, pathMatch: 'full' },
      //{ path: 'login', component: LoginComponent, pathMatch: 'full' },
      { path: 'dashboard', component: DashboardComponent, canActivate: [AuthorizeGuard]},
      { path: 'brands', component: BrandsComponent, canActivate: [AuthorizeGuard]},
      { path: 'brand/:id', component: BrandDetailsComponent, canActivate: [AuthorizeGuard] },
      { path: 'reports', component: ReportsComponent, canActivate: [AuthorizeGuard] },
      { path: 'mailings', component: MailingsComponent, canActivate: [AuthorizeGuard] },
      { path: 'mailing/:id', component: MailingDetailsComponent, canActivate: [AuthorizeGuard] },
      { path: 'mailing/report/:id', component: QCReportComponent, canActivate: [AuthorizeGuard] },
      { path: 'mailing/files/:id', component: MailingFilesComponent, canActivate: [AuthorizeGuard] },
      { path: 'mailing/notes/:id', component: MailingNotesComponent, canActivate: [AuthorizeGuard] },
      { path: 'billing', component: BillingComponent, canActivate: [AuthorizeGuard] }
    ]),
    BrowserAnimationsModule,
    MatSortModule,
    MatPaginatorModule,
    MatTableModule,
    MatInputModule,
    MatSnackBarModule, 
    NgbModule,
    MatDatepickerModule,        // <----- import(must)
    MatNativeDateModule       // <----- import for date formating(optional)
    ],
  exports: [ 
    MatDatepickerModule, 
    MatInputModule, 
    MatNativeDateModule,
    MatPaginatorModule  
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: AuthorizeInterceptor, multi: true }, MatDatepickerModule, DatePipe
  ],
  entryComponents: [
    ModalComponent,
    LocationAddFormComponent,
    LocationEditFormComponent,
    LocationOverrideFormComponent,
    ConfirmationModalComponent,
    BrandPickerComponent,
    BrandSeedFormComponent,
    SpinnerComponent,
    CreativeTemplateEditFormComponent,
    CreativeTemplateAddFormComponent,
    OverrideRuleEditFormComponent,
    OverrideRuleAddFormComponent,
    MailingRecordEditFormComponent,
    MonthConversionFormComponent,
    NoteFormComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
